import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import LaboratoryEdit from '@/ui/pages/LaboratoryEdit/LaboratoryEdit';

export const Route = createFileRoute('/_dashboard/laboratories/new')({
  beforeLoad: requireRoute('/laboratories/new'),
  component: LaboratoryEdit,
});
